import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import bemify from 'bemify-js';
import { toClass } from 'recompose';

import ClipboardButton from 'app/common/components/ClipboardButton';
import 'app/auth/components/FlankedInput.scss';

const bem = bemify('flanked-input');

const fillInInputFormatText = (value, owner, accountAndProfile) => {
  return _.template(value)({
    cid: _.get(owner, ['id']) || _.get(accountAndProfile, 'id'),
    ccode: _.get(owner, ['code']) || _.get(accountAndProfile, 'code'),
  });
};

const FlankedInput = props => {
  const owner = _.get(props.field, ['meta', 'flow', 'owner']);
  const accountAndProfile = _.get(props.field, ['meta', 'account', 'account']);
  if (props.field.input_format && (owner || accountAndProfile)) {
    const beforeInput = props.field.input_format[0]
      ? fillInInputFormatText(
          props.field.input_format[0],
          owner,
          accountAndProfile
        )
      : '';
    const afterInput = props.field.input_format[2]
      ? fillInInputFormatText(
          props.field.input_format[2],
          owner,
          accountAndProfile
        )
      : '';
    return (
      <div className={bem()}>
        <div className={bem('__input')}>
          {beforeInput}
          <div className={bem('__flanked')}>{props.children}</div>
          {afterInput}
        </div>
        {props.hasClipboardButton && (
          <ClipboardButton
            kind="large"
            text={`${beforeInput}${props.field.value}${afterInput}`}
          />
        )}
      </div>
    );
  }
  return props.children;
};

FlankedInput.propTypes = {
  config: PropTypes.object,
  classes: PropTypes.object,
  field: PropTypes.object,
  isAccordion: PropTypes.bool,
  onAction: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  replaceChoices: PropTypes.array,
  selectedChoices: PropTypes.array,
};

// formatic will pass a ref to this, so convert it to a React class:
export default toClass(FlankedInput);
